<template>
    <modal-dialog ref="modalDialog" :isLoading="isLoading">
        <template v-slot:title> Capture Signature </template>
        <template v-slot:body>
            <div id="signature-section">
                <div class="row-fluid">
                    <ul
                        class="sigNav nav nav-tabs subnavbar mb-2 signature-options"
                    >
                        <li class="drawIt" :class="{ active: isDraw }">
                            <strong
                                @click="setType(true)"
                                class="cursor-pointer"
                            >
                                <i class="cus-pencil"></i>Draw It
                            </strong>
                        </li>
                        <li class="typeIt" :class="{ active: !isDraw }">
                            <strong
                                @click="setType(false)"
                                class="cursor-pointer"
                            >
                                <i class="cus-keyboard"></i>Type It
                            </strong>
                        </li>
                    </ul>
                    <div class="draw-panel" v-if="isDraw">
                        <input
                            id="signature_output"
                            type="hidden"
                            name="signature_output"
                            class="output required"
                        />
                    </div>
                    <div class="type-panel mb-5" v-show="!isDraw">
                        <b-form-group
                            label-for="signature_name"
                            label="Name:"
                            label-cols="4"
                        >
                            <b-form-input
                                v-model="signatureName"
                                id="signature_name"
                                name="signature_name"
                                class="form-control name col-12"
                                v-validate="!isDraw ? 'required' : ''"
                                :class="{
                                    'border-danger': errors.has(
                                        'signature_name'
                                    )
                                }"
                            ></b-form-input>
                        </b-form-group>
                        <div class="typed" v-show="!isDraw"></div>
                    </div>
                    <canvas
                        @click="onDraw()"
                        class="pad"
                        :class="{ hide: !isDraw }"
                        width="450"
                        height="150"
                    ></canvas>
                </div>
            </div>
            <!-- <signature v-model="signature" ref="signature" /> -->
        </template>
        <template v-slot:confirmBtn>
            <button type="button" class="btn btn-primary" @click="save">
                Save
            </button>
            <button
                type="button"
                class="btn btn-secondary"
                @click="clearCanvas"
            >
                Reset
            </button>
        </template>
    </modal-dialog>
</template>
<style type="text/css">
.signature-options li {
    padding: 3px 10px;
    margin-bottom: -1px;
}

.signature-options li.active {
    border: 1px solid #ccc;
    border-bottom: 1px solid white;
    border-radius: 3px 3px 0 0;
}

.pad.hide {
    border: 0px;
    height: 10px;
}
</style>
<script>
import staffService from "@/services/staff";
import ModalDialog from "@/components/commons/modal-dialog";
import { STAFF_PROFILE_TAB_OPTIONS } from "@/store/staff.js";
import "@/jquery/signature/jquery.signaturepad.js";
import "@/css/signature/jquery.signaturepad.css";
export default {
    components: {
        ModalDialog
    },
    data() {
        return {
            isLoading: false,
            isDraw: true,
            signatureOutput: null,
            signatureName: null
        };
    },
    computed: {
        details() {
            return this.$store.getters["staff/staffDetails"];
        },
        refresh() {
            return this.$store.getters["staff/refresh"];
        }
    },
    methods: {
        async open() {
            this.$refs.modalDialog.open();
            this.isDraw = true;
            await this.$nextTick();
            this.initSignaturePad();
        },
        close() {
            this.clearCanvas();
            this.$refs.modalDialog.close();
        },
        clearCanvas() {
            this.signatureName = "";
            this.signatureOutput = "";
            document.querySelector(".typed").innerHTML = "";
            $("#signature-section").signaturePad().clearCanvas();
        },
        async save() {
            const signatureOutput = $("#signature_output").val();

            if (this.isDraw && !signatureOutput) {
                return;
            } else if (!this.isDraw) {
                let valid = await this.$validator.validateAll();
                if (!valid) {
                    return;
                }
            }

            this.isLoading = true;
            let params = {
                actor_id: this.details.actor_id,
                output: signatureOutput,
                name: this.signatureName ? this.signatureName : ""
            };
            try {
                const saveSignature = await staffService.saveSignature(params);
                const { code, message } = saveSignature;
                if (code == 200) {
                    if (message) {
                        this._message(message);
                        this.$store.commit(
                            "staff/setRefresh",
                            this.refresh + 1
                        );
                        this.$store.commit(
                            "staff/setStaffProfileTab",
                            STAFF_PROFILE_TAB_OPTIONS.profile
                        );
                    }
                } else {
                    this._message(
                        `Error: Cannot Save Staff Signature`,
                        "danger"
                    );
                }
            } catch (error) {
                this.isLoading = false;
                this._message(`Error : ${error.message}`, "danger");
            }

            this.close();
        },
        setType(isDraw) {
            this.$validator.reset();

            this.isDraw = isDraw;
            this.clearCanvas();
        },
        initSignaturePad() {
            $("#signature-section").signaturePad({
                defaultAction: "drawIt",
                drawOnly: false,
                clear: $(".clearButton"),
                lineWidth: 0,
                lineTop: 150,
                validateFields: true,
                penColour: "#00F",
                penWidth: 4
            });
        },
        onDraw() {
            this.signatureOutput = $("#signature_output").val();
        }
    }
};
</script>
